<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            // Плиссе 1000x1500 Неокрашенный Створка влево двухсторонний(25мм)

            let title = item.title.split(' ', 3);

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            switch (true) {
                case item.title.includes('рамный(40мм)'):
                    ind1 = 'Нет';
                    break;
                case item.title.includes('низкий(8мм)'):
                    ind1 = 'Есть';
                    break;
                case item.title.includes('двухсторонний(20мм)'):
                    ind1 = '225мм';
                    break;
                case item.title.includes('односторонний(20мм)'):
                    ind1 = '125мм';
                    break;
            }
            ind2.set(title[2]);
            ind3 = otkrivanie.find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
            webtype.set(webtypes.find((el) => item.title.toLowerCase().includes(el.toLowerCase())));
            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch($ind2);
            change();
        }
    };

    const porojek = options.porojek || {
        'Нет': 'Рамный(40мм)',
        'Есть': 'Низкий(8мм)',
        '225мм': 'Двухсторонний(20мм)',
        '125мм': 'Односторонний(20мм)',
    };

    const color = options.color || {
        'Антрацит': 'Антрацит',
        'Белый': 'Белый',
        'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
        'Неокрашенный': 'Неокрашенный',
        'Цветной': 'Цветной',
    };

    const otkrivanie = [
        'Створка влево',
        'Створка вправо',
        'Створка сверху вниз',
        'Створка снизу вверх',
        'Створка от краев к середине',
        'Створка от середины к краям'
    ];

    const webtypes = options.webtype || [
        'Обычная',
    ];

    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Плиссе', '', color);
        let options = await network.fetch_ind('Плиссе');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '2100'),
        ind1 = options.porojek ? Object.keys(options.porojek)[0] : 'Нет', // порожек
        ind2 = parameter('color', 'Белый'), // цвет
        ind3 = 'Створка влево', // открывание
        webtype = parameter('webtype', 'Обычная'), // тип сетки плиссе
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);

    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {
        fetchData = fetch($ind2)
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width - 80,
            h = +$height - 80,
            packing_items = []
        ;

        let ind1Str;

        switch (ind1) {
            case 'Нет':
                ind1Str = 'порог рамный(40мм)';
                break;

            case 'Есть':
                ind1Str = 'порог низкий(6мм)';
                break;

            case '225мм':
                ind1Str = 'порог двухсторонний(20мм)';
                break;

            case '125мм':
                ind1Str = 'порог односторонний(20мм)';
                break;
        }

        let result = {
            type: 'плиссе',
            name: 'Плиссе',
            subname: [
                $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', $webtype, ' ', ind1Str
            ].join(''),
            title: [
                'Плиссе', ' ', $width + 'x' + $height, ' ',
                $ind2, ' ', ind3, ' ', $webtype, ' ', ind1Str
            ].join(''),
            params: {
                ind1: ind1Str.replace('порог', ''),
                ind2: $ind2,
                ind3: ind3,
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 10
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name.includes('профиль мс плиссе')) {
                switch (ind1) {
                    case 'Есть': { //(Ш*1+(В+10)*2+(В-2)*1)/1000*%*цена*кол
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((w * 1 + (h + 10) * 2 + (h - 2) * 1) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w * 1 + (h + 10) * 2 + (w - 2) * 1) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = ((w * 1 + (h + 10) * 2 + (h - 2) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case 'Нет': { //(Ш*2+В*2+(В-12)*1)*%*цена*кол
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((w * 2 + h * 2 + (h - 12) * 1) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w * 2 + h * 2 + (w - 2) * 1) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = ((w * 2 + h * 2 + (h - 12) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }
                    case '125мм':
                    case '225мм': {
                        switch (ind3) {
                            case 'Створка влево':
                            case 'Створка вправо':
                                kolvo = ((w * 1 + (h + 22) * 2 + (h + 2) * 1) / 1000).toFixed(3);
                                break;

                            case 'Створка сверху вниз':
                            case 'Створка снизу вверх':
                                kolvo = ((w * 1 + (h + 22) * 2 + (w + 2) * 1) / 1000).toFixed(3);
                                break;

                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = ((w * 1 + (h + 22) * 2 + (h + 2) * 2) / 1000).toFixed(3);
                                break;
                        }
                        break;
                    }

                }
            }

            if (name.includes('порог мс плиссе')) {
                if (ind1 === 'Есть' || ind1 === 'с порогом') {
                    kolvo = (w / 1000).toFixed(3);
                }
            }
            if (name.includes('порог двухсторонний мс плиссе 25мм')) {
                if (ind1 === '225мм') {
                    kolvo = ((w + 60) / 1000).toFixed(3);
                }
            }
            if (name.includes('порог односторонний мс плиссе 25мм')) {
                if (ind1 === '125мм') {
                    kolvo = ((w + 60) / 1000).toFixed(3);
                }
            }

            if (name.includes('сетка мс плиссе')) {


                switch (true) {
                    case $webtype === 'Обычная' && (name.includes('антипыль') || name.includes('антикошка')):
                        return;

                    case $webtype === 'Антипыль' && !name.includes('антипыль'):
                        return;

                    case $webtype === 'Антикошка' && !name.includes('антикошка'):
                        return;
                }

                let k = 1;
                if (name.includes('антипыль') || name.includes('антикошка')) {
                    k = 1.1;
                }

                let wave;

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        wave = Math.ceil((h + 80) / 30 / 100 * 115);
                        kolvo = (0.05 * wave * w * k/ 1000).toFixed(3);
                        break;

                    default:
                        wave = Math.ceil((w + 80) / 30 / 100 * 115);
                        kolvo = (0.05 * wave * (h + (ind1 === 'Есть' ? 51 : 38)) * k/ 1000).toFixed(3);
                        break;
                }
            }

            if (name.includes('нить мс плиссе')) {
                let c, k, d;

                d = h;
                if (ind3 === 'Створка сверху вниз' || ind3 === 'Створка снизу вверх') {

                    d = w;
                }

                switch (true) {
                    case d + 80 < 1500: {
                        c = 4;
                        break;
                    }
                    case (d + 80 >= 2500 && d + 80 < 2700): {
                        c = 8;
                        break;
                    }
                    case d + 80 >= 2700: {
                        c = 10;
                        break;
                    }
                    default: {
                        c = 6;
                        break;
                    }
                }

                switch (ind3) {
                    case 'Створка от краев к середине':
                        k = 2;
                        break;

                    default:
                        k = 1;
                        break;
                }

                kolvo = ((w + h + 200) / 1000 * c * k).toFixed(3);
            }

            if (
                name.includes('вставной профиль плиссе') ||
                name.includes('вставка внутренняя под сетку плиссе') ||
                name.includes('скотч мс плиссе')
            ) {
                let k, d;

                switch (ind3) {
                    case 'Створка сверху вниз':
                    case 'Створка снизу вверх':
                        k = 2;
                        d = w;
                        break;

                    case 'Створка от краев к середине':

                        k = 4;
                        d = h;
                        break;

                    default:
                        k = 2;
                        d = h;
                        break;
                }

                switch (ind1) {
                    case 'Есть': { //(В+48)*2/1000*кол*%*цена+(Скотч=(В+48)*2/1000*кол*%*цена скотча)
                        kolvo = ((d + 48) * k / 1000).toFixed(3);
                        break;
                    }
                    case 'Нет': { //(В+38)*2/1000*кол*%*цена+(Скотч=(В+38)*2/1000*кол*%*цена скотча)
                        kolvo = ((d + 38) * k / 1000).toFixed(3);
                        break;
                    }

                    case '125мм':
                    case '225мм': {
                        if (ind3 === 'Створка от краев к середине') {
                            kolvo = ((d + 52 + d + 49) * 2 / 1000).toFixed(3);
                        } else {
                            kolvo = ((d + 52 + d + 49) / 1000).toFixed(3);
                        }

                        break;
                    }
                }
            }

            if (name.includes('заклеп') ||  name.includes('люверс') ) {
                let k, d, c;

                d = h;
                if (ind3 === 'Створка сверху вниз' || ind3 === 'Створка снизу вверх') {

                    d = w;
                }

                switch (true) {
                    case d + 80 < 1500: {
                        c = 4;
                        break;
                    }
                    case (d + 80 >= 2500 && d + 80 < 2700): {
                        c = 8;
                        break;
                    }
                    case d + 80 >= 2700: {
                        c = 10;
                        break;
                    }
                    default: {
                        c = 6;
                        break;
                    }
                }

                switch (ind3) {
                    case 'Створка от краев к середине':
                        k = 2;
                        break;

                    default:
                        k = 1;
                        break;
                }


                kolvo = (c * k * 2).toFixed(3);


            }
            if (name.includes('гвоздь мс плиссе')) {
                switch (ind1) {

                    case '125мм':
                    case '225мм': {
                        switch (ind3) {
                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = 2;
                                break;

                            default:
                                kolvo = 1;
                                break;
                        }
                        break;
                    }
                    default:
                        switch (ind3) {
                            case 'Створка от краев к середине':
                            case 'Створка от середины к краям':
                                kolvo = 4;
                                break;

                            default:
                                kolvo = 2;
                                break;
                        }
                }
            }

            if (name.includes('пятка мс плиссе')) {
                switch (ind3) {
                    case 'Створка от краев к середине':
                    case 'Створка от середины к краям':
                        kolvo = 4;
                        break;

                    default:
                        kolvo = 2;
                        break;
                }
            }
            if (name.includes('угол соединительный мс плиссе')) {
                switch (ind1) {
                    case '125мм':
                    case '225мм': {
                        kolvo = 2;
                        break
                    }

                    default:
                        kolvo = 4;
                        break;
                }
            }
            if (name.includes('угол п25 для одностороннего и двустороннего порога')) {
                switch (ind1) {
                    case '125мм':
                    case '225мм': {
                        kolvo = 2;
                        break
                    }
                }
            }
            if (name.includes('магнит')) {
                switch (ind3) {
                    case 'Створка от краев к середине':

                        if (name.includes('сдвоен')) {

                            kolvo = (h / 1000).toFixed(3);

                        } else {
                            kolvo = (h * 2 / 1000).toFixed(3);
                        }


                        break;

                }
            }
            if (name.includes('работа')) {
                kolvo = 1;
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }

            if (name.includes('упаковка')) {
                packing_items.push(item);
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);

        dispatch('mounting', {item: montage_item, price: montage_price});
        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000});
        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-6">
                <div class="row">
                    <div class="col-7">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Направление</label>
                                <select class="form-control form-select" bind:value={ind3}>
                                    {#each otkrivanie as item}
                                        <option value="{item}">{item}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Шир., мм ≥ 6000</label>
                                <input type="number" class="form-control text-center" step="10" min="300" max="{ options.max && options.max.width ? options.max.width : 6000 }" bind:value={$width} use:validate_int={$width}>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-7">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет</label>
                                <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                                    {#each Object.entries(color) as [value]}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">300 ≥ Выс., мм ≥ 3000</label>
                                <input type="number" class="form-control text-center" step="10" min="300" max="{ options.max && options.max.height ? options.max.height : 3000 }" bind:value={$height} use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Порожек</label>
                                <select class="form-control form-select" bind:value={ind1}>
                                    {#each Object.entries(porojek) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип сетки</label>
                                <select class="form-control form-select" bind:value={$webtype} >
                                    {#each webtypes as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-sm-6 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 250px" class="img-fluid  p-3" src="/img/plisse/ind3/{ind3.toLowerCase().replaceAll(' ', '-')}-{$ind2.toLowerCase()}.jpg"/>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}


